// extracted by mini-css-extract-plugin
export var fadeIn = "_el-1";
export var modalContent = "_el-3";
export var overlay = "_el-0";
export var popoverContent = "_el-2";
export var results = "_el-5";
export var searchInputWrapper = "_el-4";